import React from 'react';
import type { Prompt } from '@/types/intelliHealthChat';

interface PromptChipsProps {
  prompts: Prompt[];
  onSelect: (text: string) => void;
}

const PromptChips: React.FC<PromptChipsProps> = ({ prompts, onSelect }) => {
  if (prompts.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5">
      {prompts.map((prompt, i) => (
        <button
          key={i}
          onClick={() => onSelect(prompt.text)}
          className="text-xs px-3 py-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:border-brand-teal hover:text-brand-teal transition-all hover:shadow-sm"
        >
          {prompt.text}
        </button>
      ))}
    </div>
  );
};

export default PromptChips;
